<template>
  <div
    class="jira-status-select-wrap"
    :class="{
      'jira-status-select-wrap--compact': compact,
      'jira-status-select-wrap--mini': mini,
    }"
  >
    <base-select
      size="sm"
      :model-value="null"
      :options="transitionOptions"
      option-label="label"
      option-value="value"
      :placeholder="localDisplayStatus || '—'"
      :disabled="disabled || updating || !issueKey"
      @update:model-value="onSelectTransition"
    />
    <span v-if="updating" class="jira-status-select__loading text-xs text-secondary">
      <i class="fas fa-spinner fa-spin me-1"></i>
    </span>
  </div>
</template>

<script>
import { applyJiraTransition, fetchJiraTransitions } from "@/services/jiraStatusApi";

export default {
  name: "JiraStatusSelect",
  props: {
    issueKey: { type: String, required: true },
    status: { type: String, default: "" },
    transitions: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    mini: { type: Boolean, default: false },
    autoLoadTransitions: { type: Boolean, default: true },
  },
  emits: ["update:status", "update:transitions", "error"],
  data() {
    return {
      updating: false,
      localTransitions: [],
      localDisplayStatus: "",
    };
  },
  computed: {
    transitionOptions() {
      return (this.localTransitions || []).map((t) => ({
        label: t.name,
        value: String(t.id),
      }));
    },
  },
  watch: {
    status: {
      immediate: true,
      handler(v) {
        this.localDisplayStatus = v || "";
      },
    },
    transitions: {
      immediate: true,
      handler(v) {
        this.localTransitions = Array.isArray(v) ? [...v] : [];
      },
    },
    issueKey: {
      immediate: true,
      handler() {
        if (this.autoLoadTransitions && this.issueKey && this.localTransitions.length === 0) {
          this.loadTransitions();
        }
      },
    },
  },
  methods: {
    async loadTransitions() {
      if (!this.issueKey) return;
      try {
        const data = await fetchJiraTransitions(this.issueKey);
        this.localTransitions = data.transitions;
        if (data.status) {
          this.localDisplayStatus = data.status;
          this.$emit("update:status", data.status);
        }
        this.$emit("update:transitions", data.transitions);
      } catch (e) {
        this.$emit("error", e.message);
      }
    },
    async onSelectTransition(transitionId) {
      if (!transitionId || !this.issueKey) return;
      this.updating = true;
      try {
        const data = await applyJiraTransition(this.issueKey, transitionId);
        this.localTransitions = data.transitions;
        if (data.status) {
          this.localDisplayStatus = data.status;
          this.$emit("update:status", data.status);
        }
        this.$emit("update:transitions", data.transitions);
      } catch (e) {
        this.$emit("error", e.message);
        alert("เปลี่ยน status ไม่สำเร็จ: " + e.message);
      } finally {
        this.updating = false;
      }
    },
  },
};
</script>

<style scoped>
.jira-status-select-wrap {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
  width: 100%;
}
.jira-status-select-wrap--compact {
  min-width: 5.5rem;
}
.jira-status-select-wrap--mini {
  width: 6.25rem;
  max-width: 6.25rem;
}
.jira-status-select-wrap--mini :deep(.base-select__trigger) {
  font-size: 0.65rem;
  padding: 0.15rem 1.1rem 0.15rem 0.3rem;
}
.jira-status-select-wrap--compact :deep(.base-select__trigger) {
  font-size: 0.7rem;
}
.jira-status-select__loading {
  flex-shrink: 0;
}
</style>
